export const MOBILE_PATHS = {
  home: '/',
  recording: '/recording',
  finish: '/finish/:recordingId',
  sessions: '/sessions',
  createRespondent: '/respondents/new'
} as const;

export const finishPath = (recordingId: string): string => `/finish/${recordingId}`;

export const sessionsSearchPath = (): string => `${MOBILE_PATHS.sessions}?q=`;

export default MOBILE_PATHS;
